import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-target": "#activity_report",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Course Activity Report")
  ])
], -1)
const _hoisted_3 = {
  id: "activity_report",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Tranche")
], -1)
const _hoisted_10 = { class: "col-md-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Training Partner")
], -1)
const _hoisted_12 = { class: "col-md-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Type", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { class: "col-md-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Start Date")
], -1)
const _hoisted_17 = { class: "col-md-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "End Date")
], -1)
const _hoisted_19 = { class: "col-md-2 mt-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_21 = {
  key: 1,
  disabled: "",
  type: "button",
  class: "btn btn-success mt-6 p-3",
  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_23 = {
  key: 0,
  class: "d-flex pt-4 pb-2"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-4 text-gray-600" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "mt-2" })
    ])
  ])
], -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col d-flex align-items-center" })
], -1)
const _hoisted_27 = { class: "position-relative" }
const _hoisted_28 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 bg-success cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#activity-report",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Course Activity Report")
  ])
], -1)
const _hoisted_30 = {
  id: "activity-report",
  class: "collapse show"
}
const _hoisted_31 = { class: "collapse show" }
const _hoisted_32 = { class: "card-body border-top p-9" }
const _hoisted_33 = {
  class: "table table-borderless",
  style: {"border":"1.5px solid #23ce10"}
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("thead", { style: {"border-left":"1.5px solid #23ce10"} }, [
  /*#__PURE__*/_createElementVNode("tr", { style: {"border-bottom":"1px solid #23ce10"} }, [
    /*#__PURE__*/_createElementVNode("th", null, "Sl"),
    /*#__PURE__*/_createElementVNode("th", null, "Association"),
    /*#__PURE__*/_createElementVNode("th", null, "Target(New Entrant)"),
    /*#__PURE__*/_createElementVNode("th", null, "Total Enrollment"),
    /*#__PURE__*/_createElementVNode("th", null, "Female Enrolled"),
    /*#__PURE__*/_createElementVNode("th", null, "% of Female"),
    /*#__PURE__*/_createElementVNode("th", null, "Total Certified"),
    /*#__PURE__*/_createElementVNode("th", null, "Female Certified"),
    /*#__PURE__*/_createElementVNode("th", null, "% of Female"),
    /*#__PURE__*/_createElementVNode("th", null, "Total Employed"),
    /*#__PURE__*/_createElementVNode("th", null, "Female Employed"),
    /*#__PURE__*/_createElementVNode("th", null, "% of Female")
  ])
], -1)
const _hoisted_35 = { style: {} }
const _hoisted_36 = { colspan: "9" }
const _hoisted_37 = { class: "border border-gray-400 text-center" }
const _hoisted_38 = { colspan: "2" }
const _hoisted_39 = { class: "border border-gray-400 text-center" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, " Total ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[6] || (_cache[6] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.tranche_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tranche_id) = $event)),
                      options: _ctx.optionsTranche,
                      mode: "tags",
                      "clear-on-select": false,
                      placeholder: "Select Tranche",
                      "close-on-select": false,
                      searchable: true,
                      "create-option": true
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.entity_id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.entity_id) = $event)),
                      options: _ctx.optionsTPartner,
                      mode: "tags",
                      "clear-on-select": false,
                      placeholder: "Select Training Partner",
                      "close-on-select": false,
                      searchable: true,
                      "create-option": true
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _hoisted_14,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Training Type",
                      modelValue: _ctx.course_type,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.course_type) = $event)),
                      style: {"width":"100%"},
                      onChange: _ctx.btnCheckStatus
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, { value: "upskill" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Up Skill")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, { value: "newentrant" }, {
                          default: _withCtx(() => [
                            _createTextVNode("New Entrant")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createVNode(_component_el_form_item, {
                      prop: "date",
                      class: "mb-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.start_date,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.start_date) = $event)),
                          "value-format": "YYYY-MM-DD",
                          format: "DD-MM-YYYY",
                          type: "date",
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createVNode(_component_el_form_item, {
                      prop: "date",
                      class: "mb-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.end_date,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.end_date) = $event)),
                          "value-format": "YYYY-MM-DD",
                          format: "DD-MM-YYYY",
                          type: "date",
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    (_ctx.btnCheck)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.courseActivityReport())),
                          type: "button",
                          class: "btn btn-success mt-6 p-3",
                          style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                        }, [
                          _createTextVNode(" Search "),
                          _hoisted_20
                        ]))
                      : (_openBlock(), _createElementBlock("button", _hoisted_21, [
                          _createTextVNode(" Search "),
                          _hoisted_22
                        ]))
                  ])
                ]),
                (_ctx.showActivityReport == true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
                  : _createCommentVNode("", true),
                (_ctx.showActivityReport == true)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                      _hoisted_26,
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _hoisted_29,
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("table", _hoisted_33, [
                                  _hoisted_34,
                                  _createElementVNode("tbody", _hoisted_35, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.activityReport, (info, key) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                                        _createElementVNode("tr", null, [
                                          _createElementVNode("td", _hoisted_36, [
                                            _createElementVNode("b", null, _toDisplayString(info?.trancheInfo?.label), 1)
                                          ])
                                        ]),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info?.trancheInfo
                                    ?.entities, (data, inx) => {
                                          return (_openBlock(), _createElementBlock("tr", {
                                            key: inx,
                                            class: "border border-gray-400 text-center"
                                          }, [
                                            _createElementVNode("td", null, _toDisplayString(inx + 1), 1),
                                            _createElementVNode("td", null, _toDisplayString(data?.entity_short_name), 1),
                                            _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(data?.targetTrainee)), 1),
                                            _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(data?.enrollment)), 1),
                                            _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(data?.female)), 1),
                                            _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(
                                          data?.female_enrollment_percentage
                                        )), 1),
                                            _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(data?.certification)), 1),
                                            _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(
                                          data?.female_certification
                                        )), 1),
                                            _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(
                                          data?.certification_percentage?.toFixed(
                                            2
                                          )
                                        )), 1),
                                            _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(data?.job_placement)), 1),
                                            _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(
                                          data?.female_job_placement
                                        )), 1),
                                            _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(
                                          data?.job_placement_percentage?.toFixed(
                                            2
                                          )
                                        )), 1)
                                          ]))
                                        }), 128)),
                                        _createElementVNode("tr", _hoisted_37, [
                                          _createElementVNode("td", _hoisted_38, [
                                            _createElementVNode("b", null, " Subtotal(" + _toDisplayString(info?.trancheInfo?.label) + ")", 1)
                                          ]),
                                          _createElementVNode("td", null, _toDisplayString(info?.trancheInfo?.subTotalTrainee), 1),
                                          _createElementVNode("td", null, _toDisplayString(info?.trancheInfo?.subTotalenrollment), 1),
                                          _createElementVNode("td", null, _toDisplayString(info?.trancheInfo?.subTotalfemale), 1),
                                          _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(
                                        (
                                          (info?.trancheInfo?.subTotalfemale /
                                            info?.trancheInfo
                                              ?.subTotalenrollment) *
                                          100
                                        ).toFixed(2)
                                      )), 1),
                                          _createElementVNode("td", null, _toDisplayString(info?.trancheInfo?.subTotalcertification), 1),
                                          _createElementVNode("td", null, _toDisplayString(info?.trancheInfo
                                        ?.subTotalfemaleCertification), 1),
                                          _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(
                                        (
                                          (info?.trancheInfo
                                            ?.subTotalfemaleCertification /
                                            info?.trancheInfo
                                              ?.subTotalcertification) *
                                          100
                                        ).toFixed(2)
                                      )), 1),
                                          _createElementVNode("td", null, _toDisplayString(info?.trancheInfo?.subtotal_job_placement), 1),
                                          _createElementVNode("td", null, _toDisplayString(info?.trancheInfo
                                        ?.subtotal_female_job_placement), 1),
                                          _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(
                                        (
                                          (info?.trancheInfo
                                            ?.subtotal_female_job_placement /
                                            info?.trancheInfo
                                              ?.subtotal_job_placement) *
                                          100
                                        ).toFixed(2)
                                      )), 1)
                                        ])
                                      ], 64))
                                    }), 128)),
                                    _createElementVNode("tr", _hoisted_39, [
                                      _hoisted_40,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(this.TotalTrainee)), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(this.Totalenrollment)), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(this.Totalfemale)), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(
                                      (
                                        (this.Totalfemale /
                                          this?.Totalenrollment) *
                                        100
                                      ).toFixed(2)
                                    )), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(this.Totalcertification)), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(
                                      this.TotalcertificationFemale
                                    )), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(
                                      (
                                        (this.TotalcertificationFemale /
                                          this?.Totalcertification) *
                                        100
                                      ).toFixed(2)
                                    )), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(this.total_job_placement)), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(
                                      this.total_female_job_placement
                                    )), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(
                                      (
                                        (this.total_female_job_placement /
                                          this?.total_job_placement) *
                                        100
                                      ).toFixed(2)
                                    )), 1)
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])), [
                      [_directive_loading, _ctx.load]
                    ])
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}